
import './App.css';
import Heeader from './components/Header/Heeader';
import TopTeacher from './components/TopTeacher/TopTeacher';



function App() {
  return (
    <div>
      <Heeader></Heeader>
      <TopTeacher></TopTeacher>

    </div>
  );
}

export default App;
